export { default as LoginForm } from './LoginForm/LoginForm';
export { default as RegisterForm } from './RegisterForm/RegisterForm';
export { default as ForgotPasswordForm } from './ForgotPasswordForm/ForgotPasswordForm';
export { default as ResetPasswordForm } from './ResetPasswordForm/ResetPasswordForm';